import { useMemo } from 'react'
import { Link as InnerLink } from 'react-router'

import { MenuItem } from 'tools/Menu'
import { Icon } from 'tools/Uniform/Icons'

export function Link({ Type = InnerLink, to = '', onClick, ...args }) {
  if (Type === InnerLink && !to && !onClick) {
    Type = 'div'
    console.error('Disabling link with bad args', { Type, ...args })
  }

  return <Type to={to} onClick={onClick} {...args} />
}

export function NavLink({
  className = 'navlink',
  icon,
  label,
  children,
  ...args
}) {
  return (
    <Link className={className} {...args}>
      {icon}
      {label || children}
    </Link>
  )
}

// tools/Menu
export function MenuLink({ className = 'ph3 pv2 hover-hilite', ...other }) {
  return (
    <MenuItem className={className}>
      <NavLink {...other} />
    </MenuItem>
  )
}

export function ExtLink({
  to,
  children = undefined,
  target = '_blank',
  className = 'flex-items gh2',
  label = '',
  icon = false
}) {
  children = useMemo(() => {
    if (!children) {
      try {
        const url = new URL(to)
        return `${label ? label : ''}${url.hostname}`
      } catch (err) {
        console.log('link error', { err, to })
      }
    } else {
      return children
    }
  }, [label, to, children])
  return (
    <a href={to} className={className} rel="noopener noreferrer" target={target}>
      {children}
      {icon && <Icon type="link" />}
    </a>
  )
}

// export function DownloadLink({
//   filename,
//   data,
//   ext,
//   children,
//   className = undefined
// }) {
//   const [url, setUrl] = useState('')
//   const updateState = useCallback(() => {
//     const url = getExportFileUrl(stringify(data))
//     setUrl(url)
//   }, [data])
//
//   return (
//     <a
//       href={url}
//       download={filename + '.' + ext}
//       target="_blank"
//       rel="noopener noreferrer"
//       className={`${className} ${url ? 'pointer' : 'cursor-wait'}`}
//       onMouseEnter={updateState}
//     >
//       {children}
//     </a>
//   )
// }

export function Action({ className = '', icon = undefined, children, ...props }) {
  return (
    <Link
      className={`${className} button flex-center pa1 ph2 f1 gh2 w-100`}
      {...props}
    >
      {icon && <Icon type={icon} />}
      {children}
    </Link>
  )
}

export default Link
